// extracted by mini-css-extract-plugin
module.exports = {"share":"CartShare_share__DldTi","button":"CartShare_button__2DdAX"};